import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { store } from './store'
import { Provider } from 'react-redux'
import App from './App';
import theme from './theme';
import './index.css';
import './fonts/fonts.css';
import reportWebVitals from './reportWebVitals';

import './i18n';
import PageLoading from './components/loading';

ReactDOM.render(

  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Suspense fallback={<PageLoading />}>
          <CssBaseline />
          <App />
        </Suspense>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
